import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full max-w-md space-y-6 rounded-2xl border border-gray-200 bg-white p-8 text-left shadow-lg sm:text-center" }
const _hoisted_2 = { class: "space-y-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg font-semibold leading-snug text-red-600"
}
const _hoisted_4 = { class: "whitespace-pre-line text-base leading-relaxed text-gray-600" }
const _hoisted_5 = { class: "text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CognitoBrandedShell = _resolveComponent("CognitoBrandedShell")!

  return (_openBlock(), _createBlock(_component_CognitoBrandedShell, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.errorHeading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorHeading), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errorDetail), 1)
        ]),
        _createElementVNode("p", _hoisted_5, [
          (_ctx.nextStepIsFreshSignIn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Signing you out so you can sign up again in " + _toDisplayString(_ctx.redirectSecondsRemaining) + " seconds… ", 1)
              ], 64))
            : (_ctx.nextStepIsCompanyHome)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Redirecting to the expert app in " + _toDisplayString(_ctx.redirectSecondsRemaining) + " seconds... " + _toDisplayString(_ctx.redirectSecondsRemaining === 1 ? "" : "s") + ". ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(" Redirecting to the expert app in " + _toDisplayString(_ctx.redirectSecondsRemaining) + " seconds… ", 1)
                ], 64))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "w-full rounded-lg bg-[#9489F5] px-4 py-3 text-sm font-medium text-white shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#9489F5] focus:ring-offset-2 focus:ring-offset-white",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.completeInterstitial && _ctx.completeInterstitial(...args)))
        }, _toDisplayString(_ctx.primaryButtonLabel), 1)
      ])
    ]),
    _: 1
  }))
}